module.exports = __webpack_public_path__ + "static/img/00.70372757.png";